import { Document, Page, Text } from "@react-pdf/renderer";
import { getTenantStore } from "../../../../stores/tenantStore";
import { buildReportingHubFilePreviewUrl } from "../../../../utils/reports";
import { styles } from "../../ReactPdfStyles";
import AnalysisAndActionSection from "../AnalysisAndAction";
import PdfHeader from "../PdfHeader";
import ReportingApprovalRecordSection from "../ReportingApprovalRecordSection";
import ReportingFileList from "../ReportingFileList";
import ReportingProjectDetailSection from "../ReportingProjectDetailSection";
import IncidentConsequenceSection from "./IncidentConsequenceSection";
import IncidentDetailSection from "./IncidentDetailSection";
import RiskMatrixSection from "../RiskMatrixSection";

export default function IncidentPDFTemplate({
	data,
}: {
	data: Record<string, any>;
}) {
	const tenantList = getTenantStore().getTenantList();
	const tenant = tenantList.find(
		(tenant: any) => tenant.value === data.operator
	);
	const reportLogoUrl = tenant?.report_logo ?? tenant?.logo;
	const containerId = tenant?.container_id;

	const renderFiles = () => {
		const files = data.additional_files;
		if (!files.length) return <Text>—</Text>;
		const origin = window.location.origin;
		const previewUrl = `${origin}/reporting/incident-stream/${data._id}/preview`;
		return (
			<ReportingFileList
				files={files}
				buildUrl={(fileObj: any) =>
					containerId
						? buildReportingHubFilePreviewUrl(previewUrl, fileObj, containerId)
						: null
				}
			/>
		);
	};

	return (
		<Document>
			<Page size="A4" style={styles.document} orientation="portrait">
				<PdfHeader
					reportTitle="INCIDENT REPORT"
					data={{
						internal_report: data.internal_report,
						report_number: data.report_number,
						title: data.title,
					}}
					reportLogo={reportLogoUrl}
				/>
				<ReportingProjectDetailSection data={data} />
				<IncidentDetailSection data={data} renderFiles={renderFiles} />
				<IncidentConsequenceSection data={data} />
				<ReportingApprovalRecordSection data={data} />
				<AnalysisAndActionSection data={data} />
			</Page>

			<Page size="A4" style={styles.documentTight} orientation="landscape">
				<PdfHeader
					reportTitle="INCIDENT REPORT"
					data={{
						internal_report: data.internal_report,
						report_number: data.report_number,
						title: data.title,
					}}
				/>
				<RiskMatrixSection />
			</Page>
		</Document>
	);
}
